<template>
  <article class="message" :class="getClass()">
    <div class="message-body">
      <slot></slot>
    </div>
  </article>
</template>
<script>
  export default {
    name: 'message-component',
    props: {
      level: {
        type: String,
        required: false
      }
    },
    methods: {
      getClass () {
        return {
          'is-success': this.level === 'success',
          'is-danger': this.level === 'danger',
          'is-warning': this.level === 'warning',
          'is-info': this.level === 'info'
        }
      }
    }
  }
</script>
<style lang="sass" scoped>
  .message-body
    overflow: auto
</style>
